import CreateValueModule from "@/redux/create-value-module";

import {
    $ProfileSidebarModuleName,
    TProfileSidebarState
} from "./profileSidebar.types";

const { constants: _constants, actions } =
    CreateValueModule<TProfileSidebarState>($ProfileSidebarModuleName, {
        active: false
    });

export const clear = actions.clear;
export const set = actions.set;
export const update = actions.update;

export const constants = _constants;
